import { createContext } from 'react';

export type DisabledContext = readonly [boolean, (disabled: boolean) => void];

export const disabledContext_INTERNAL = createContext<DisabledContext | null>(
  null
);
